import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { checkPermission } from "utils/HelperFunctions";
import { PERMISSIONS_NAME, UNASSIGNED } from "lib/constants";
import { useLocation } from "react-router-dom";
import BaseModal from "components/molecules/Modals/BaseModal";
import useWorkspaceSubscription from "hooks/useWorkspaceSubscription";
import TeamsList from "./components/Teams";
import TeamMembersList from "./components/TeamMembersList";

function Teams() {
  const routerLocation = useLocation();
  const { subscription } = useWorkspaceSubscription();
  const user = useSelector((state) => state.loginUser.loginUserState);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [isSeatCountModalOpen, setIsSeatCountModalOpen] = useState(false);
  const hasEditTeamPermission = checkPermission(PERMISSIONS_NAME.MANAGE_USERS, user.userPermission);

  const locationSearch = routerLocation.search;

  useEffect(() => {
    if (locationSearch) {
      const searchParams = new URLSearchParams(locationSearch);
      const selectedTeam = searchParams.get("team");
      if (selectedTeam === "unassigned") {
        setSelectedTeamId(UNASSIGNED);
      }
    }
  }, []);

  const showTeamsList =
    user.type === "company" ||
    checkPermission(PERMISSIONS_NAME.MANAGE_WORKSPACE, user.userPermission) ||
    checkPermission(PERMISSIONS_NAME.MANAGE_USERS, user.userPermission);

  const handleSeatCountCheck = async (cb) => {
    if (!subscription?.openSeatCount) {
      setIsSeatCountModalOpen(true);
    } else {
      cb();
    }
  };

  let seatCountModelDescription;
  if (subscription?.isOnFreeTrial) {
    seatCountModelDescription =
      "You're currently on a free trial. Once you select a plan, you'll be able to manage your subscription and add more seats.";
  } else if (!hasEditTeamPermission) {
    seatCountModelDescription =
      "You have hit your maximum seat count. Please contact a system admin to increase.";
  } else {
    seatCountModelDescription = `Your current seat count is ${subscription?.seatCount}. You have the maximum number of active users. Purchase more seats using the link below.`;
  }

  if (!showTeamsList) {
    return null;
  }

  if (selectedTeamId) {
    return (
      <>
        <TeamMembersList
          teamId={selectedTeamId}
          setSelectedTeamId={setSelectedTeamId}
          handleSeatCountCheck={handleSeatCountCheck}
        />
        <BaseModal
          open={isSeatCountModalOpen}
          modalTitle="seat-count-warning-modal"
          modalDescribedBy="seat-count-warning-description"
          title="At Seat Count Limit"
          text={seatCountModelDescription}
          setOpen={setIsSeatCountModalOpen}
          cancelOnly={subscription?.isOnFreeTrial || !hasEditTeamPermission}
          cancelLabel="Close"
          confirmLabel="Manage"
          onConfirmCb={() => window.open(subscription?.subscriptionManagementUrl, "_blank")}
        />
      </>
    );
  }

  return (
    <>
      <TeamsList
        setSelectedTeamId={setSelectedTeamId}
        handleSeatCountCheck={handleSeatCountCheck}
      />
      <BaseModal
        open={isSeatCountModalOpen}
        modalTitle="seat-count-warning-modal"
        modalDescribedBy="seat-count-warning-description"
        title="At Seat Count Limit"
        text={seatCountModelDescription}
        setOpen={setIsSeatCountModalOpen}
        cancelOnly={subscription?.isOnFreeTrial || !hasEditTeamPermission}
        cancelLabel="Close"
        confirmLabel="Manage"
        onConfirmCb={() => window.open(subscription?.subscriptionManagementUrl, "_blank")}
      />
    </>
  );
}

export default Teams;
